import { render } from "./EconomicConfig.vue?vue&type=template&id=30e79b52"
import script from "./EconomicConfig.vue?vue&type=script&lang=js"
export * from "./EconomicConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__